import React from "react";
import { Zap } from "lucide-react";

const URL_SPLIT_RE = /(https?:\/\/[^\s<>"']+)/gi;

const isSuspicious = (url) => {
  try {
    const u = new URL(url);
    if (u.protocol === "http:") return true;                    // unencrypted
    if (/^\d{1,3}(\.\d{1,3}){3}$/.test(u.hostname)) return true; // raw IP
    if (u.hostname.includes("xn--")) return true;                // punycode lookalike
    return false;
  } catch {
    return true;
  }
};

// Renders message/comment text with URLs linkified and a Plyx Cyber Guard
// screening badge next to every link. Heuristic screening runs locally;
// the badge deep-links to plyxcyberguard.com.
export const GuardedText = ({ text, className }) => {
  if (!text) return null;
  const parts = String(text).split(URL_SPLIT_RE);
  if (parts.length === 1) return <span className={className}>{text}</span>;
  return (
    <span className={className}>
      {parts.map((part, i) => {
        if (!part) return null;
        if (!/^https?:\/\//i.test(part)) return <React.Fragment key={i}>{part}</React.Fragment>;
        const bad = isSuspicious(part);
        return (
          <span key={i}>
            <a
              href={part}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="underline underline-offset-2 break-all"
              onClick={(e) => e.stopPropagation()}
            >
              {part}
            </a>
            <a
              href="https://plyxcyberguard.com"
              target="_blank"
              rel="noopener noreferrer"
              title={bad
                ? "This link looks suspicious — scan it with Plyx Cyber Guard before opening"
                : "Link screened by Plyx Cyber Guard"}
              data-testid="cyberguard-link-badge"
              onClick={(e) => e.stopPropagation()}
              className={`ml-1.5 inline-flex items-center gap-0.5 align-middle px-1.5 py-[1px] rounded text-[9px] font-bold uppercase tracking-wide border whitespace-nowrap ${
                bad
                  ? "text-[#FFB42D] border-[#FFB42D]/60"
                  : "text-[#00FF41] border-[#00FF41]/50"
              }`}
              style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}
            >
              <Zap className="w-2.5 h-2.5" /> {bad ? "Check link" : "Cyber Guard"}
            </a>
          </span>
        );
      })}
    </span>
  );
};
